/* eslint-disable */
require('script-loader!file-saver');
require('./Blob.js');
require('script-loader!xlsx/dist/xlsx.core.min');
import XLSXS from "xlsx-style"

function generateArray(table) {
    var out = [];
    var rows = table.querySelectorAll('tr');
    var ranges = [];
    for (var R = 0; R < rows.length; ++R) {
        var outRow = [];
        var row = rows[R];
        var columns = row.querySelectorAll('td');
        for (var C = 0; C < columns.length; ++C) {
            var cell = columns[C];
            var colspan = cell.getAttribute('colspan');
            var rowspan = cell.getAttribute('rowspan');
            var cellValue = cell.innerText;
            if (cellValue !== "" && cellValue == +cellValue) cellValue = +cellValue;

            //Skip ranges
            ranges.forEach(function (range) {
                if (R >= range.s.r && R <= range.e.r && outRow.length >= range.s.c && outRow.length <= range.e.c) {
                    for (var i = 0; i <= range.e.c - range.s.c; ++i) outRow.push(null);
                }
            });

            //Handle Row Span
            if (rowspan || colspan) {
                rowspan = rowspan || 1;
                colspan = colspan || 1;
                ranges.push({s: {r: R, c: outRow.length}, e: {r: R + rowspan - 1, c: outRow.length + colspan - 1}});
            }
            ;

            //Handle Value
            outRow.push(cellValue !== "" ? cellValue : null);

            //Handle Colspan
            if (colspan) for (var k = 0; k < colspan - 1; ++k) outRow.push(null);
        }
        out.push(outRow);
    }
    return [out, ranges];
};

function datenum(v, date1904) {
    if (date1904) v += 1462;
    var epoch = Date.parse(v);
    return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}

function sheet_from_array_of_arrays(data, opts) {
    var ws = {};
    var range = {s: {c: 10000000, r: 10000000}, e: {c: 0, r: 0}};
    for (var R = 0; R != data.length; ++R) {
        for (var C = 0; C != data[R].length; ++C) {
            if (range.s.r > R) range.s.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.r < R) range.e.r = R;
            if (range.e.c < C) range.e.c = C;
            var cell = {v: data[R][C]};
            if (cell.v == null) continue;
            var cell_ref = XLSX.utils.encode_cell({c: C, r: R});

            if (typeof cell.v === 'number') cell.t = 'n';
            else if (typeof cell.v === 'boolean') cell.t = 'b';
            else if (cell.v instanceof Date) {
                cell.t = 'n';
                cell.z = XLSX.SSF._table[14];
                cell.v = datenum(cell.v);
            }
            else cell.t = 's';

            ws[cell_ref] = cell;
        }
    }
    if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
    return ws;
}

function Workbook() {
    if (!(this instanceof Workbook)) return new Workbook();
    this.SheetNames = [];
    this.Sheets = {};
}

function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}

export function export_table_to_excel(id) {
    var theTable = document.getElementById(id);
    var oo = generateArray(theTable);
    var ranges = oo[1];

    /* original data */
    var data = oo[0];
    var ws_name = "SheetJS";

    var wb = new Workbook(), ws = sheet_from_array_of_arrays(data);

    /* add ranges to worksheet */
    // ws['!cols'] = ['apple', 'banan'];
    ws['!merges'] = ranges;

    /* add worksheet to workbook */
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;

    var wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: false, type: 'binary'});

    saveAs(new Blob([s2ab(wbout)], {type: "application/octet-stream"}), "test.xlsx")
}

export function export_json_to_excel(th, jsonData, defaultTitle) {

    /* original data */

    var data = jsonData;
    data.unshift(th);
    var ws_name = "SheetJS";

    var wb = new Workbook(), ws = sheet_from_array_of_arrays(data);


    /* add worksheet to workbook */
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;

    var wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: false, type: 'binary'});
    var title = defaultTitle || '列表'
    saveAs(new Blob([s2ab(wbout)], {type: "application/octet-stream"}), title + ".xlsx")
}

// 带合并单元格功能的

export function export_json_to_excelhb({
    multiHeader = [], // 第一行表头
    multiHeader2 = [], // 第二行表头
    header, // 第三行表头
    data,//传递的数据
    filename, //文件名
    merges = [], // 合并
    cell ='',
    autoWidth = true,//用于设置列宽的
    bookType = 'xlsx'
} = {}) {
    /* original data */
    filename = filename || '列表';
    data = [...data]
    data.unshift(header);
    for (let i = multiHeader2.length - 1; i > -1; i--) {
        data.unshift(multiHeader2[i])
    }
    for (let i = multiHeader.length - 1; i > -1; i--) {
        data.unshift(multiHeader[i])
    }
    var ws_name = "SheetJS";
    var wb = new Workbook(),
        ws = sheet_from_array_of_arrays(data);
    let borderAll = { //单元格外侧框线
        top: {
            style: 'medium',
        },
        bottom: {
            style: 'medium'
        },
        left: {
            style: 'medium'
        },
        right: {
            style: 'medium'
        }
    };
    for (let key in ws) {
        if (ws[key] instanceof Object) {
            // console.log(key === 'A1')
            if(key === cell) {
                ws[key].s = {
                    border: borderAll,
                    alignment: {
                        horizontal: 'center', //水平居中对齐
                        vertical: 'center',//垂直居中
                        wrapText: 1,//自动换行
                    },
                    font: {
                        sz: 18,//单元格中字体的样式与颜色设置
                        color: {
                            rgb: '495060'
                        }
                    },
                    bold: true,
                    numFmt: 0
                }
            } else{
                ws[key].s = {
                    border: borderAll,
                    alignment: {
                        horizontal: 'center', //水平居中对齐
                        vertical: 'center',//垂直居中
                        wrapText: 1,//自动换行
                    },
                    font: {
                        sz: 14,//单元格中字体的样式与颜色设置
                        color: {
                            rgb: '495060'
                        }
                    },
                    bold: true,
                    numFmt: 0
                }
            }
        }
    }
    ws['I2'] = ws['H2'] = ws['G2'] = ws['F2'] = ws['E2'] = ws['D2'] = ws['C2'] = ws['B2'] = ws['A2']//用于第二行的单元格的样式设置（如果是合并的第一行，就是1）
    // 补齐空单元格边框：sheet_from_array_of_arrays 会跳过值为空的单元格（未写入工作表），
    // 导致导出后空白单元格没有边框。这里按实际数据行数/列数补全所有缺失单元格并加边框。
    // 注意：整行全为空的单元格（如最底部签名行）不会出现在 !ref 中，因此行数必须以 data 为准兜底。
    const wsRange = ws['!ref']
    const ref = wsRange ? XLSX.utils.decode_range(wsRange) : {s: {r: 0, c: 0}, e: {r: -1, c: -1}}
    const totalRows = data.length // 实际行数（含表头与全空行）
    const totalCols = Math.max(ref.e.c + 1, header ? header.length : 0)
    for (let r = 0; r < totalRows; r++) {
        for (let c = 0; c < totalCols; c++) {
            const cellRef = XLSX.utils.encode_cell({r: r, c: c})
            if (!ws[cellRef]) {
                ws[cellRef] = {
                    v: '',
                    t: 's',
                    s: {
                        border: borderAll,
                        alignment: {
                            horizontal: 'center', //水平居中对齐
                            vertical: 'center', //垂直居中
                            wrapText: 1, //自动换行
                        }
                    }
                }
            }
        }
    }
    if (merges.length > 0) {
        if (!ws['!merges']) ws['!merges'] = [];
        merges.forEach(item => {
            ws['!merges'].push(XLSX.utils.decode_range(item))
        })
    }
    if (autoWidth) {
        let colWidths = [];
        // 计算每一列的所有单元格宽度
        // 先遍历行
        data.forEach((row) => {
            // 列序号
            let index = 0
            // 遍历列
            for (const key in row) {
                if (colWidths[index] == null) colWidths[index] = []
                switch (typeof row[key]) {
                    case 'string':
                    case 'number':
                    case 'boolean':                     colWidths[index].push(getCellWidth(row[key]))
                        break
                    case 'object':
                    case 'function':
                        colWidths[index].push(0)
                        break
                }
                index++
            }
        })
        ws['!cols'] = [];
        colWidths.forEach((widths, index) => {
            // 计算列头的宽度
            widths.push(getCellWidth(header[index]))
            // 设置最大值为列宽
            ws['!cols'].push({
                wch: Math.max(...widths)
            })
        })
    }
    // ws['!rows'] = [];
    // console.log(ws['!rows']);
    /* add worksheet to workbook */
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    var wbout = XLSXS.write(wb, {
        bookType: bookType,
        bookSST: false,
        type: 'binary'
    });
    saveAs(new Blob([s2ab(wbout)], {
        type: "application/octet-stream"
    }), `${filename}.${bookType}`);
}
export function getCellWidth(value) {
    if (value == null) {
        return 10
    } else if (value.toString().charCodeAt(0) > 255) {
        // 判断是否包含中文
        let length = value.toString().length * 2
        if (length > 60) {
            length = length - 40 
//这里的宽度可以自己设定，在前面设置wrapText: 1可以在单元格内换行
        }
        return length
    } else {
        return value.toString().length * 1.2
    }
}
